import React from "react";
import { observer } from "mobx-react";
import { Button, Divider, Stack, Text } from "@chakra-ui/react";
import { translations } from "@/constants/translations";
import { useStore } from "@/store";
import { CanadaMap } from "@/components/CanadaMap";
import { renderInnerHtml } from "@/helpers/dom";
import { useAppNavigate } from "@/routing/useAppNavigate";
import { H3 } from "@/components/Heading";
import type { Province } from "@/store/types/province";
import { telemetry } from "@/telemetry";

export const ContactPage = observer(() => {
  const {
    activeLanguage,
    activeProvinceId,
    getProvincePrefix,
    showLeavingModal,
  } = useStore();
  const language = translations.pages["contact"][activeLanguage];
  const provinceTranslations = translations.common.provinces[activeLanguage];
  const linkTranslations = translations.common["contact-links"][activeLanguage];
  const navigate = useAppNavigate();
  const handleReturnHome = () =>
    navigate({
      to: "/",
    });

  const contactLink =
    (linkTranslations as any)[activeProvinceId as Province] ??
    linkTranslations.default;

  const pleaseVisitYour =
    (language.please_visit_your as any)[activeProvinceId as Province] ??
    language.please_visit_your.default;

  const handleFindResource = () => {
    telemetry.trackEvent("contact_link_clicked");
    showLeavingModal(contactLink);
  };

  return (
    <Stack
      spacing="14"
      alignItems="center"
      textAlign="center"
    >
      <CanadaMap svgProps={{ height: "250" }} />
      <H3 maxW="container.md">
        {renderInnerHtml(pleaseVisitYour)}
        {getProvincePrefix(activeProvinceId!)}
        <Text
          as="span"
          color="primary-light"
          whiteSpace="nowrap"
        >
          {provinceTranslations[activeProvinceId!]}
        </Text>
        .
      </H3>

      <Button onClick={handleFindResource}>{language.find_resource}</Button>

      <Divider />

      <Button onClick={handleReturnHome}>{language.return_home}</Button>
    </Stack>
  );
});
